export default {
  title: 'Contacts',
  noQuoteRequests: 'Aucune demande de devis',
  noContacts: 'Aucun contact',
  showRequest: 'Voir la demande',
  labels: {
    projectName: 'Nom du projet',
  },
  quoteRequestRespondModal: {
    acceptTitle: 'Accepter une demande de soumission.',
    acceptedTitle: 'Demande de soumission acceptée',
    declineTitle: 'Refuser une demande de soumission.',
    declinedTitle: 'Demande de soumission déclinée',
    clientName: 'De la part de',
    projectType: 'Type de projet',
    responsible: 'Responsable',
    acceptButton: 'Utiliser 1 jeton et accepter',
    acceptingButton: 'Acceptation...',
    showNewContact: 'Voir mon nouveau contact',
    creditNote: '1 demande = 1 jeton',
    acceptedMessage:
      'Vous pouvez maintenant soumettre votre soumission à {{requesterName}} à  partir du <bold>Créateur de projet de soumission.</bold>.',
    jobNotAvailable: "Ce projet n'est plus disponible. Vous ne pouvez plus accepter cette demande.",
    acceptError:
      "Une erreur inconnue est survenue lors de l'acceptation de la demande. Veuillez réessayer ou contacter le support.",
    declineButton: 'Refuser',
    decliningButton: 'Déclination...',
    declineReasonLabel: 'Message pour <bold>{{freelancerName}}</bold>',
    declineMessageDescription:
      'Pour Refuser la demande de soumission de <bold>{{ requesterName }}</bold>, vous devez rédiger une brève explication.',
    declineMessagePlaceholder: 'Rédigez une brève explication pour Refuser la demande',
    declineSuccess:
      'Vous avez décliné la demande de <bold>{{ requesterName}}</bold>. Une notification lui sera envoyée avec votre message.',
    declineError:
      'Une erreur inconnue est survenue lors du refus de la demande. Veuillez réessayer ou contacter le support.',
    manageQuotes: 'Gérer mes soumissions',
    startQuote: 'Commencer ma soumission',
    requestMessageLabel: 'Message',
    continueQuote: 'Continuer ma soumission',
    insufficientCredits: 'Crédits insuffisants',
    insufficientCreditsNote: 'Vous avez besoin de crédits pour répondre à cette demande.',
  },
  quoteRequestList: {
    allianceQuoteRequestMessage: 'Vous invite à participer à sa soumission',
    quoteRequestMessage: 'Vous êtes invités à envoyer une soumission pour ce projet.',
  },
  contacts_title: 'Mes contacts',
} as const;
